import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackMobileAppQrCodeShown.meta';

export type MobileAppQrCodeLocation = 'integrations' | 'help-menu';

export type UseTrackMobileAppQrCodeShownParams = {
  location: MobileAppQrCodeLocation;
};

export const useTrackMobileAppQrCodeShown = () => {
  const { track } = useAnalyticsUtilities();

  const trackMobileAppQrCodeShown = useCallback(
    (params: UseTrackMobileAppQrCodeShownParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackMobileAppQrCodeShown };
};
